import { render, staticRenderFns } from "./TK036TeikiIkkatuDetailParts.vue?vue&type=template&id=0442b16c&"
import script from "./TK036TeikiIkkatuDetailParts.vue?vue&type=script&lang=js&"
export * from "./TK036TeikiIkkatuDetailParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports